import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export default function ClientPortal({ children, selector = '#overlay-root' }) {
    const [mounted, setMounted] = useState(false);
    const [container, setContainer] = useState(null);

    useEffect(() => {
        setContainer(document.querySelector(selector));
        setMounted(true);
    }, [selector]);

    if (!mounted || !container) return null;
    return createPortal(children, container);
}
